import { useFetch, useRuntimeConfig, type UseFetchOptions } from 'nuxt/app'

// services/fetcher.ts
type FetchMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'

export interface FetchOptions {
    params?: Record<string, any>
    body?: Record<string, any>
    headers?: HeadersInit
}

export const createFetch = () => {
    const config = useRuntimeConfig()
    // const { logout } = useAuth()

    const call = async <T = any>(
        url: string,
        method: FetchMethod,
        options: Partial<UseFetchOptions<T>> = {},
    ): Promise<{ data: T | null, error: T | null }> => {
        const { data, error } = await useFetch<T>(url, {
            baseURL: config.public.BASE_URL,
            method,
            params: options.params,
            body: options.body,
            headers: options.headers,
            watch: false,
        })

        if (error.value) {
            const msg = error.value?.data?.error?.detail || error.value?.data || 'Unknown error'
            const messageObj =
                typeof msg === 'string'
                    ? msg
                    : msg?.message || JSON.stringify(msg)

            if (messageObj === 'Unauthorized') {
                // logout()
                // navigateTo('/login')
            }

            return { data: null, error: msg }
        }

        return { data: data.value, error: null }
    }

    return {
        get: <T>(url: string, options?: FetchOptions) => call<T>(url, 'GET', options),
        post: <T>(url: string, options?: FetchOptions) => call<T>(url, 'POST', options),
        put: <T>(url: string, options?: FetchOptions) => call<T>(url, 'PUT', options),
        del: <T>(url: string, options?: FetchOptions) => call<T>(url, 'DELETE', options),
        patch: <T>(url: string, options?: FetchOptions) => call<T>(url, 'PATCH', options),
    }
}
